import React from 'react';
import Navbar from '@components/web-landingpage/NavBar';
import FooterComponent from '@components/web-landingpage/Footer';
import link_image_twitter from '../public/images/seo/link_image_twitter.png';
import { GetStaticProps } from 'next';
import Script from 'next/script';
import TermsPage from '@components/web-landingpage/Terms.Page';
import Head from 'next/head';

const metaTags = [
  {
    name: 'description',
    content:
      "Check out this page to learn more about the terms by which you may use Mimo's online and/or mobile services, website, and apps.",
  },
  {
    name: 'og:description',
    content:
      "Check out this page to learn more about the terms by which you may use Mimo's online and/or mobile services, website, and apps.",
  },
  {
    property: 'og:title',
    content: "Learn more about Mimo's Terms of Service",
  },
  {
    property: 'og:image',
    content: `https://mimo.org${link_image_twitter.src}`,
  },
  {
    property: 'og:url',
    content: 'https://mimo.org',
  },
  {
    property: 'og:type',
    content: 'website',
  },
  {
    property: 'og:site_name',
    content: 'Mimo: Learn to Code',
  },
  {
    property: 'fb:app_id',
    content: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID,
  },
  {
    name: 'twitter:url',
    content: 'https://mimo.org',
  },
  {
    name: 'twitter:title',
    content: "Learn more about Mimo's Terms of Service",
  },
  {
    name: 'twitter:card',
    content: 'summary_large_image',
  },
];

export default function Terms() {
  return (
    <>
      <Head>
        <title>Learn more about Mimo&apos;s Terms of Service</title>
        {metaTags.map((tag) => (
          <meta {...tag} key={tag.name || tag.property} />
        ))}
      </Head>
      <div>
        <Script
          id="cookieyes"
          type="text/javascript"
          src="https://cdn-cookieyes.com/client_data/3ac4d695a7fb984394170f54/script.js"
          strategy="beforeInteractive"
        />
        <Navbar></Navbar>
        <div className="flex justify-center">
          <div className="flex w-full max-w-xl flex-col space-y-4">
            <TermsPage hideTopSpace={false} />
          </div>
        </div>
        <FooterComponent></FooterComponent>
      </div>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
